define('prototypes/templateFactory',['template!blocks/product-block','template!blocks/listing/top-infos','template!blocks/news-block','template!blocks/video'],function($,productBlock,listingTopInfos){
});
